<template>
  <q-form ref="editForm">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-card
          v-if="popupParam.userManualId"
          title="개정"
          class="cardClassDetailForm revisionLayout"
          topClass="topcolor-orange"
        >
          <template v-slot:card-detail>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div class="row">
                <div class="col-2">
                  <c-text
                    :required="editable && isRevision"
                    :editable="editable && isRevision"
                    label="개정번호"
                    name="revisionNum"
                    v-model="userManual.revisionNum"
                  />
                </div>
                <div class="col-2">
                  <c-text
                    :editable="false"
                    label="개정일시"
                    name="regDtStr"
                    v-model="userManual.regDtStr"
                  />
                </div>
                <div class="col-2">
                  <c-text
                    :editable="false"
                    label="개정자"
                    name="regUserName"
                    v-model="userManual.regUserName"
                  />
                </div>
                <div class="col-6">
                  <c-text
                    :required="editable && isRevision"
                    :editable="editable && isRevision"
                    label="개정사유"
                    name="revisionContent"
                    v-model="userManual.revisionContent"
                  />
                </div>
              </div>
            </div>
          </template>
        </c-card>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-card title="사용자매뉴얼 기본정보" class="cardClassDetailForm">
          <template v-slot:card-select>
            <c-select
              v-if="popupParam.userManualId"
              :editable="!isRevision"
              :comboItems="gridrev.data"
              type="custom"
              typetext="개정이력"
              itemText="revisionNum"
              itemValue="userManualId"
              name="selectedUserManualId"
              label=""
              v-model="selectedUserManualId"
              @datachange="rowClickRev"
            />
          </template>
          <template v-slot:card-button>
            <q-btn-group outline>
              <c-btn
                v-show="editable && popupParam.userManualId && !isRevision"
                label="개정"
                icon="restart_alt"
                @btnClicked="setRevision"
              />
              <c-btn
                v-show="editable && popupParam.userManualId && isRevision"
                label="개정취소"
                icon="restart_alt"
                @btnClicked="cancelRevision"
              />
              <c-btn
                v-if="editable && popupParam.userManualId"
                label="삭제"
                icon="remove"
                @btnClicked="deleteData"
              />
              <c-btn
                v-if="editable"
                :url="saveUrl"
                :isSubmit="isSave"
                :param="userManual"
                :mappingType="mappingType"
                label="저장"
                icon="save"
                @beforeAction="saveData"
                @btnCallback="saveCallback"
              />
            </q-btn-group>
          </template>
          <template v-slot:card-detail>
            <div class="col-3">
              <c-text
                :editable="false"
                label="문서일련번호"
                name="userManualId"
                v-model="userManual.userManualId"
              />
            </div>
            <div class="col-6">
              <c-text
                :required="true"
                :editable="editable"
                label="업무명"
                name="taskName"
                v-model="userManual.taskName"
              />
            </div>
            <div class="col-12">
              <c-textarea
                :editable="editable"
                label="업무개요"
                name="taskSummary"
                autogrow
                v-model="userManual.taskSummary"
              />
            </div>
          </template>
        </c-card>
      </div>
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="padding-top: 20px !important"
      >
        <c-upload
          :attachInfo="attachInfo"
          :editable="editable"
          label="사용자매뉴얼 첨부파일"
        />
      </div>
    </div>
  </q-form>
</template>

<script>
import { uid } from "quasar";
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "userManualDetail",
  props: {
    popupParam: {
      type: Object,
      default() {
        return {
          userManualId: "",
        };
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return "auto";
      },
    },
  },
  data() {
    return {
      gridrev: {
        data: [],
      },
      attachInfo: {
        isSubmit: "",
        taskClassCd: "USER_MANUAL",
        taskKey: "",
        beforeTaskKey: "",
        isRev: false,
      },
      userManual: {
        userManualId: "", // 사용자매뉴얼 일련번호
        taskName: "", // 업무명
        taskSummary: "", // 업무개요
        deleteFlag: "N", // 삭제여부
        revisionNum: "",
        groupId: "",
        sysRevision: 1,
        revisionContent: "제정",
        regDtStr: "",
        regUserName: "",
      },
      editable: true,
      isSave: false,
      isdelete: false,
      isRevision: false,
      selectedUserManualId: null,
      detailUrl: "",
      saveUrl: "",
      deleteUrl: "",
      revlistUrl: "",
      saveCallData: "",
      mappingType: "POST",
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // code setting
      this.detailUrl = selectConfig.um.userManual.get.url;
      this.deleteUrl = transactionConfig.um.userManual.delete.url;
      this.saveUrl = transactionConfig.um.userManual.save.url;
      this.revlistUrl = selectConfig.um.userManual.list.url + "/revs";
      this.getData();
    },
    getData() {
      this.isRevision = false;
      if (this.popupParam.userManualId) {
        this.attachInfo.taskKey = this.popupParam.userManualId;
        this.getDetail(this.popupParam.userManualId, true);
        this.selectedUserManualId = this.popupParam.userManualId;
      }
    },
    getDetail(_userManualId, _check) {
      this.$http.url = this.$format(this.detailUrl, _userManualId);
      this.$http.type = "GET";
      this.$http.request((_result) => {
        this.userManual = _result.data;
        if (_result.data)
          this.userManual.regDtStr = _result.data.regDtStr.slice(0, -2);
        this.$emit("setRegInfo", _result.data); // 상세팝업 최초작성/최근수정 정보 노출
        this.isRevision = false;
        if (_check) this.getRevList(_result.data.groupId);
        if (_result.data.userManualId === this.popupParam.userManualId) {
          this.editable = this.$route.meta.editable;
        } else this.editable = false;
      });
    },
    saveData() {
      if (this.popupParam.userManualId) {
        this.userManual.chgUserId = this.$store.getters.user.userId;
        this.mappingType = "PUT";
      } else {
        this.userManual.regUserId = this.$store.getters.user.userId;
        this.mappingType = "POST";
      }
      this.$refs["editForm"].validate().then((_result) => {
        if (_result) {
          window.getApp.$emit("CONFIRM", {
            title: "LBLCONFIRM", // 확인
            message: this.isRevision
              ? "현재버전을 개정하여 저장하시겠습니까?"
              : "저장하시겠습니까?",
            type: "info", // success / info / warning / error
            confirmCallback: () => {
              this.userManual.deleteFlag = "N";
              // 개정시
              if (this.isRevision) {
                this.mappingType = "POST";
                this.userManual.sysRevision =
                  parseInt(this.userManual.sysRevision) + 1;
              }
              this.isSave = !this.isSave;
            },
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit("APP_VALID_ERROR");
        }
      });
    },
    saveCallback(result) {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      if (this.mappingType === "POST")
        this.popupParam.userManualId = result.data.userManualId;
      this.saveCallData = uid();
      this.$set(this.attachInfo, "taskKey", result.data.userManualId);
      this.$set(this.attachInfo, "isSubmit", uid());
      this.$set(this.attachInfo, "beforeTaskKey", "");
      this.$set(this.attachInfo, "isRev", false);
      this.getData();
    },
    deleteData() {
      window.getApp.$emit("CONFIRM", {
        title: "LBLCONFIRM", // 확인
        message: "MSGREMOVE", // 삭제하시겠습니까?,
        type: "warning", // success / info / warning / error
        confirmCallback: () => {
          this.$http.url = this.$format(
            this.deleteUrl,
            this.popupParam.userManualId,
          );
          this.$http.type = "DELETE";
          this.$http.request(() => {
            this.isdelete = !this.isdelete;
            window.getApp.$emit("APP_REQUEST_SUCCESS");
            this.$emit("closePopup");
          });
        },
        cancelCallback: () => {},
      });
    },
    getRevList(_groupId) {
      this.$http.url = this.revlistUrl;
      this.$http.type = "GET";
      this.$http.param = { groupId: _groupId };
      this.$http.request((_result) => {
        this.gridrev.data = _result.data;
      });
    },
    setRevision() {
      this.$http.url = selectConfig.com.revision.getversion;
      this.$http.param = { revisionNum: this.userManual.revisionNum };
      this.$http.type = "GET";
      this.$http.request((_result) => {
        this.userManual.revisionNum = _result.data;
        this.userManual.revisionContent = "";
        this.userManual.regDtStr = "";
        this.userManual.regUserName = "";
        this.isRevision = true;
        // 첨부파일 셋팅
        this.$set(this.attachInfo, "taskKey", "");
        this.$set(
          this.attachInfo,
          "beforeTaskKey",
          this.popupParam.userManualId,
        );
        this.$set(this.attachInfo, "isRev", true);
      });
    },
    cancelRevision() {
      this.isRevision = false;
      this.$set(this.attachInfo, "taskKey", this.popupParam.userManualId);
      this.$set(this.attachInfo, "beforeTaskKey", "");
      this.$set(this.attachInfo, "isRev", false);
      this.getData();
    },
    rowClickRev(row) {
      if (row && row != this.userManual.userManualId) {
        this.selectedUserManualId = row;
        this.getDetail(this.selectedUserManualId, false);
        this.$set(this.attachInfo, "taskKey", this.selectedUserManualId);
      }
    },
  },
};
</script>
